export const isMissingBuzzScoreError = error => {
  const status = error?.response?.status;
  if (status === 404) return true;

  const data = error?.response?.data;
  const message = [
    data?.error,
    data?.detail,
    typeof data === 'string' ? data : '',
    error?.message,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  return message.includes('no buzz score found');
};

export const hasBuzzScore = buzz => {
  const score = buzz?.buzz_score ?? buzz?.summary?.b;
  return score != null && score !== '' && !Number.isNaN(Number(score));
};
